<script lang="ts">
  /**
   * The proto's inline SVG icons, one component. Stroke follows currentColor;
   * size follows the parent's CSS (width/height on `svg`).
   */
  export type IconName =
    | 'home' | 'calendar' | 'trend' | 'plan'
    | 'back' | 'chevron-left' | 'chevron-right' | 'undo'
    | 'check' | 'move' | 'shuffle' | 'camera' | 'trash';

  let { name, width = 2 }: { name: IconName; width?: number } = $props();

  const STROKE: Partial<Record<IconName, number>> = {
    back: 2.4, 'chevron-left': 2.4, 'chevron-right': 2.4, undo: 2.2,
    check: 3, move: 2.4, shuffle: 2.2,
  };

  let sw = $derived(STROKE[name] ?? width);
</script>

<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={sw} stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  {#if name === 'home'}
    <path d="M3 11 12 3l9 8" /><path d="M5 10v10h14V10" />
  {:else if name === 'calendar'}
    <rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18M8 2v4M16 2v4" />
  {:else if name === 'trend'}
    <path d="M3 20h18" /><path d="m4 15 5-6 4 3 7-8" />
  {:else if name === 'plan'}
    <rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" />
  {:else if name === 'back' || name === 'chevron-left'}
    <path d="M15 18l-6-6 6-6" />
  {:else if name === 'chevron-right'}
    <path d="M9 18l6-6-6-6" />
  {:else if name === 'undo'}
    <path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" />
  {:else if name === 'check'}
    <path d="M5 12l5 5L20 7" />
  {:else if name === 'move'}
    <path d="M13 4 9 9l4 3-3 6" /><circle cx="16" cy="3" r="1.5" /><path d="m9 9-4 1 M13 12l4 2" />
  {:else if name === 'shuffle'}
    <path d="M16 3h5v5" /><path d="M4 20 21 3" /><path d="M21 16v5h-5" /><path d="m15 15 6 6" /><path d="m4 4 5 5" />
  {:else if name === 'camera'}
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" /><circle cx="12" cy="13" r="3" />
  {:else if name === 'trash'}
    <path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" />
  {/if}
</svg>
